import React, { useState } from "react";

export default function InviteHistory({ invites, invitesError, hasMoreInvites, onLoadMore }) {
  const [showInactiveInvites, setShowInactiveInvites] = useState(false);

  const renderInviteItem = (inv) => {
    const now = new Date();
    const expiresAt = inv.expiresAt?.toDate?.() ?? null;
    const status = inv.usedBy
      ? "Used"
      : expiresAt && expiresAt < now
        ? "Expired"
        : "Active";
    const statusColor = status === "Active" ? "text-accent" : "text-text-muted";
    return (
      <li key={inv.id} className="flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-border py-2 last:border-0 text-sm">
        <span className="font-mono font-medium text-text-primary">{inv.id}</span>
        <span className="text-text-secondary">
          Created {inv.createdAt?.toDate?.()?.toLocaleDateString() ?? "—"}
        </span>
        <span className="text-text-secondary">
          Expires {expiresAt?.toLocaleDateString() ?? "—"}
        </span>
        <span className={`ml-auto ${statusColor}`}>{status}</span>
      </li>
    );
  };

  const now = new Date();
  const activeInvites = invites.filter((inv) => !inv.usedBy && inv.expiresAt?.toDate?.() > now);
  const inactiveInvites = invites.filter((inv) => inv.usedBy || !(inv.expiresAt?.toDate?.() > now));

  return (
    <div className="mt-4 rounded-md border border-border bg-surface p-4">
      <h2 className="mb-4 text-sm font-medium text-text-primary">Invite History</h2>

      {invitesError && (
        <p className="mb-3 text-sm text-danger">{invitesError}</p>
      )}

      {invites.length === 0 ? (
        <p className="text-sm text-text-secondary">No invites generated yet.</p>
      ) : (
        <>
          {activeInvites.length === 0 ? (
            <p className="text-sm text-text-secondary">No active invites.</p>
          ) : (
            <ul className="space-y-2">{activeInvites.map(renderInviteItem)}</ul>
          )}

          {inactiveInvites.length > 0 && (
            <>
              <p
                className="text-xs text-text-muted hover:text-text-primary cursor-pointer mt-4 mb-2 flex items-center gap-1 select-none"
                onClick={() => setShowInactiveInvites((v) => !v)}
              >
                <span>{showInactiveInvites ? "▾" : "▸"}</span>
                Used &amp; Expired ({inactiveInvites.length})
              </p>
              {showInactiveInvites && (
                <ul className="space-y-2">{inactiveInvites.map(renderInviteItem)}</ul>
              )}
            </>
          )}

          {hasMoreInvites && (
            <div className="mt-3 text-center">
              <button
                type="button"
                className="text-xs text-text-secondary hover:text-text-primary"
                onClick={onLoadMore}
              >
                Load more
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
